import {Http} from 'vue-resource'
import config from '../config'

class QuestionStepDescriptionService {
  static getQuestionTypes () {
    return Http.get(config.API_URL + 'api/question-types')
  }
}

export default QuestionStepDescriptionService
